class RoutineBuilder extends HTMLElement {
  connectedCallback() {
    this.pct = Number(this.dataset.percent) || 0;
    this.code = this.dataset.code;
    this.addEventListener('change', () => this.update());
    this.querySelector('[data-add]').addEventListener('click', () => this.add());
    this.update();
  }
  selected() {
    return [...this.querySelectorAll('[data-item]')].filter((li) => {
      const c = li.querySelector('[data-check]');
      return !c || c.checked;
    });
  }
  update() {
    const items = this.selected();
    const sum = items.reduce((s, li) => s + Number(li.dataset.price), 0);
    const discounted = items.length > 1 ? Math.round(sum * (1 - this.pct / 100)) : sum;
    const old = this.querySelector('[data-old]');
    old.textContent = discounted < sum ? theme.money(sum) : '';
    this.querySelector('[data-new]').textContent = theme.money(discounted);
    const save = this.querySelector('[data-save]');
    save.hidden = discounted >= sum;
    save.textContent = `-${this.pct}%`;
    this.querySelector('[data-add]').disabled = !items.length;
  }
  async add() {
    const btn = this.querySelector('[data-add]');
    const err = this.querySelector('[data-error]');
    err.hidden = true;
    btn.setAttribute('aria-disabled', 'true');
    try {
      const items = this.selected().map((li) => ({ id: Number(li.dataset.id), quantity: 1, properties: { _routine: 'true' } }));
      if (items.length > 1 && this.code) await fetch(`/discount/${encodeURIComponent(this.code)}`, { credentials: 'same-origin' });
      await theme.addToCart(items);
      theme.flyToCart((this.selected()[0] && this.selected()[0].querySelector('img')) || btn);
      theme.toast(window.themeStrings.added, true);
    } catch (e) {
      err.textContent = e.message;
      err.hidden = false;
    } finally {
      btn.removeAttribute('aria-disabled');
    }
  }
}
customElements.define('routine-builder', RoutineBuilder);
